import { Camera } from "../camera";
import { CameraSettings } from "../cameraSettings";
import { CameraManager } from "./cameraManager";

/**
 * A dummy barcode picker utility class used to (not) handle camera interaction.
 */
// istanbul ignore next
export class DummyCameraManager extends CameraManager {
  public setInteractionOptions(_1: boolean, _2: boolean, _3: boolean, _4: boolean): void {
    return;
  }

  public isCameraSwitcherEnabled(): boolean {
    return false;
  }

  public async setCameraSwitcherEnabled(_1: boolean): Promise<void> {
    return;
  }

  public isTorchToggleEnabled(): boolean {
    return false;
  }

  public setTorchToggleEnabled(_1: boolean): void {
    return;
  }

  public isTapToFocusEnabled(): boolean {
    return false;
  }

  public setTapToFocusEnabled(_1: boolean): void {
    return;
  }

  public isPinchToZoomEnabled(): boolean {
    return false;
  }

  public setPinchToZoomEnabled(_1: boolean): void {
    return;
  }

  public setInitialCameraType(_1?: Camera.Type): void {
    return;
  }

  public async setCameraType(_1?: Camera.Type): Promise<void> {
    return;
  }

  public setSelectedCamera(_1?: Camera): void {
    return;
  }

  public setSelectedCameraSettings(_1?: CameraSettings): void {
    return;
  }

  public async setupCameras(): Promise<void> {
    return;
  }

  public async stopStream(): Promise<void> {
    return;
  }

  public async applyCameraSettings(_1?: CameraSettings): Promise<void> {
    return;
  }

  public async reinitializeCamera(): Promise<void> {
    return;
  }

  public async initializeCameraWithSettings(_1: Camera, _2?: CameraSettings): Promise<void> {
    return;
  }

  public async setTorchEnabled(_1: boolean): Promise<void> {
    return;
  }

  public async toggleTorch(): Promise<void> {
    return;
  }

  public async setZoom(_1: number, _2?: number): Promise<void> {
    return;
  }
}
